import React from 'react';

function TrustBadgeOrg() {
  return (
    <div style={styles.banner} role="status">
      <span style={styles.icon} aria-hidden="true">🛡️</span>
      <span style={styles.text}>Anonymous &amp; employer-invisible</span>
    </div>
  );
}

const styles = {
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#f0fdf4',
    border: '1px solid #bbf7d0',
    borderRadius: '8px',
    padding: '8px 14px',
    fontSize: '13px',
    fontWeight: '500',
    color: '#166534',
  },
  icon: {
    fontSize: '16px',
  },
  text: {
    lineHeight: 1.4,
  },
};

export default TrustBadgeOrg;
